import { WithT } from '@/locales/types'
import { FullScreenBackdrop } from '../dialog/FullScreenBackDrop'
import { CommentInput } from './CommentInput'
import { IImage } from '@/api/interfaces/IImage'
import {
  IBaseCommentRO,
  ICommentUpdateFunction,
} from '@/api/interfaces/IComment'

interface CommentEditDialogProps<T extends IBaseCommentRO> {
  domainId: number
  commendId: number
  body: string | null
  image?: IImage | null
  updateFn: ICommentUpdateFunction
  onUpdate: (comment: T) => void
}

export const CommentEditDialog = <T extends IBaseCommentRO>({
  domainId,
  translations,
  commendId,
  body,
  image,
  updateFn,
  onUpdate,
}: WithT<CommentEditDialogProps<T>>) => {
  return (
    <FullScreenBackdrop token={`comment-edit-${domainId}-${commendId}`}>
      <div className="bg-dialog rounded-xl p-4 w-[600px] max-w-full">
        <CommentInput
          translations={translations}
          updateFn={updateFn}
          commentId={commendId}
          initialBody={body}
          initialImage={image}
          domainId={domainId}
          onCreateOrUpdate={onUpdate}
        />
      </div>
    </FullScreenBackdrop>
  )
}
